import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LoaderState } from '../models/common/loader.model';

@Injectable()

export class LoaderService {

  public runningServicesCount: number = 0;

  private loaderSubject = new Subject<LoaderState>();

  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show() {
    this.loaderSubject.next(<LoaderState>{ show: true });
  }

  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }

  /* Method to set loader to show uninterrupted by other calls completing */
  showActive() {
    this.runningServicesCount++;
    this.show();
  }

  hideActive() {
    this.runningServicesCount--;
    if (this.runningServicesCount <= 0) {
      this.runningServicesCount = 0;
      this.hide();
    }
  }
}